import { render, staticRenderFns } from "./ProfileMuniTransferDocuments.vue?vue&type=template&id=05d99b0a&scoped=true&"
import script from "./ProfileMuniTransferDocuments.vue?vue&type=script&lang=js&"
export * from "./ProfileMuniTransferDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMuniTransferDocuments.vue?vue&type=style&index=0&id=05d99b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d99b0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d99b0a')) {
      api.createRecord('05d99b0a', component.options)
    } else {
      api.reload('05d99b0a', component.options)
    }
    module.hot.accept("./ProfileMuniTransferDocuments.vue?vue&type=template&id=05d99b0a&scoped=true&", function () {
      api.rerender('05d99b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProfileMuniTransferDocuments.vue"
export default component.exports